import { setErrorState } from './error-state';

export default {
  setErrorState
};